import type { PaletteOptions, ThemeOptions } from '@mui/material/styles';
import { alpha, createTheme } from '@mui/material/styles';

const borderColor = '#D8DFDE';

export const or2Palette: PaletteOptions = {
  mode: 'light',
  primary: {
    main: '#008FE1',
    contrastText: '#fff',
  },
  secondary: {
    main: '#E6EEF2',
  },
  error: {
    main: '#EF5350',
  },
  warning: {
    main: '#FFA726',
    contrastText: '#fff',
  },
  tonalOffset: 0.1,
};

const themeOptions: ThemeOptions = {
  palette: or2Palette,
  typography: {
    fontSize: 15,
    fontFamily: 'modernera, "Helvetica Neue", Helvetica, Arial, sans-serif',
    button: {
      textTransform: 'none',
    },
  },
  shape: {
    borderRadius: 20,
  },
  components: {
    MuiButtonBase: {
      defaultProps: {
        disableRipple: true, // No more ripple, on the whole application 💣!
      },
    },
    // Ensure notistack/MUI Snackbar content uses our rounded theme shape
    MuiSnackbarContent: {
      styleOverrides: {
        root: ({ theme }) => ({
          borderRadius: theme.shape.borderRadius,
        }),
      },
    },
    // Also round MUI Alert in case it's used inside snackbars
    MuiAlert: {
      styleOverrides: {
        root: ({ theme }) => ({
          borderRadius: theme.shape.borderRadius,
        }),
      },
    },
  },
  background: '#F1F5F8',
  secondaryBackground: '#FAFAFA',
  darkCard: '#F4F7F7',
  washingLineItemBorder: '#CCE0F4',
  washingLineItemBorderActive: '#008FE1',
  washingLineItem: '#E5F1FA',
  washingLineItemText: '#12263F',
  boxShadow: '0px 8px 8px rgba(216, 216, 216, 0.5)',
  boxShadowHighlight: '0px 8px 8px rgba(0, 143, 225, 0.2)',
  hint: 'rgba(0, 0, 0, 0.38)',
  hover: alpha('rgba(0, 0, 0, 0.87)', 0.04),
  cardBorder: borderColor,
  avatarBorder: borderColor,
  letterAvatarBackground: '#BDBDBD',
  infoBackground: 'rgb(229, 246, 253)',
  infoText: 'rgb(1, 67, 97)',
};

export const or2Theme = createTheme(themeOptions);
